import { ConfigProviderContext } from '@fx-ui/fine-design';
import { useContext } from 'react';

const useConfigProvider = () => {
    const config = useContext(ConfigProviderContext);
    return config;
};

export default useConfigProvider;
